<template>
  <div class="card card-plain">
    <div class="card-header">
      <div class="row">
        <div class="col-12 ms-auto text-center">
          <img
            class="border-radius-lg img-fluid reward-frame reward-zoom"
            :src="imgRoot + RewardDetail.RewardImg"
            alt="reward"
            role="button"
            @click.stop="openRewardPhoto"
          >
        </div>
      </div>
    </div>
    <div class="card-body">
      <h5>{{ RewardDetail.RewardName }}</h5>
      <h6 class="text-normal">Hodnota: <span class="text-bold">{{ store.getters.formatNumber(RewardDetail.RewardCredit) }}</span></h6>
      <p class="card-text">{{ RewardDetail.RewardText }}</p>
      <button
        v-if="RewardDetail.RewardID"
        type="button"
        class="forum-open-btn mt-3"
        :class="{ 'forum-open-btn-dark': isDarkMode }"
        :title="'Fórum: ' + (RewardDetail.RewardName || 'odměna')"
        @click.stop="openRewardForum"
      >
        <fa-icon icon="fa-regular fa-comment-dots" />
        Fórum
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { rewardLightboxPayload } from "@/helpers/rewardGallery";

const store = useStore();

const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);
const isDarkMode = computed(() => !!store.state.isDarkMode);
const RewardDetail = computed(() => store.state.RewardDetail || {});

const openRewardForum = () => {
  if (!RewardDetail.value.RewardID) return;
  store.dispatch("openForum", {
    title: RewardDetail.value.RewardName || "Odměna",
    RewardID: RewardDetail.value.RewardID,
    Img: RewardDetail.value.RewardImg
  });
};

const openRewardPhoto = () => {
  const payload = rewardLightboxPayload(
    imgRoot.value,
    RewardDetail.value.RewardName || "Výhra",
    RewardDetail.value.RewardImg,
    RewardDetail.value.RewardImgs
  );
  if (!payload.src) return;
  store.dispatch("openLightbox", payload);
};
</script>

<style scoped>
.reward-frame {
  width: 100%;
  aspect-ratio: 455 / 355;
  object-fit: cover;
}

.reward-zoom {
  cursor: zoom-in;
}

.forum-open-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1.5px solid #CBD5E1;
  background: transparent;
  color: #64748B;
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: pointer;
}

.forum-open-btn:hover {
  color: #FF8A4C;
  border-color: #FF8A4C;
}

.forum-open-btn-dark {
  border-color: #94A3B8;
  color: #CBD5E1;
}

.forum-open-btn-dark:hover {
  color: #FF8A4C;
  border-color: #FF8A4C;
}
</style>